"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/** SignupMixin class */
var SignupMixin = /** @class */ (function () {
    function SignupMixin() {
    }
    /**
     * getSignups
     * @param query
     * @param restrictions
     * @param overallStatusFilter
     * @param productType
     * @param callback
     */
    SignupMixin.prototype.getSignups = function (query, restrictions, overallStatusFilter, productType, callback) {
        var _this = this;
        var urlParams = {};
        if (restrictions.length != 0) {
            urlParams['restrictions'] = restrictions.map(function (r) { return models_1.SignupRestrictionsEnum[r]; }).join('+');
        }
        if (overallStatusFilter.length != 0) {
            urlParams['overallStatusFilter'] = overallStatusFilter.map(function (f) { return models_1.OverallSignupStatusEnum[f]; }).join('+');
        }
        if (productType != null) {
            urlParams['productType'] = models_1.SignupProductType[productType];
        }
        if (query != null) {
            urlParams['query'] = query;
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.MinimalSignup.parse, 'warn'));
        };
        this.http.get('/signups', urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSignup
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.getSignup = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.Signup.parse));
        };
        this.http.get("/signups/" + signupId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSignupStatus
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.getSignupStatus = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.SignupStatus.parse));
        };
        this.http.get("/signups/" + signupId + "/status", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * updateSignupStatus
     * @param signupId
     * @param parserStatus
     * @param dataStatus
     * @param callback
     */
    SignupMixin.prototype.updateSignupStatus = function (signupId, parserStatus, dataStatus, callback) {
        var _this = this;
        var body = {
            parserStatus: parserStatus != null ? models_1.ParserStatusEnum[parserStatus] : null,
            dataStatus: dataStatus != null ? models_1.DataStatusEnum[dataStatus] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/signups/" + signupId + "/status", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSignupContacts
     * @param signupId
     * @param query
     * @param callback
     */
    SignupMixin.prototype.getSignupContacts = function (signupId, query, callback) {
        var _this = this;
        var urlParams = query != null ?
            { query: query }
            : null;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.Contact.parse, 'warn'));
        };
        this.http.get("/signups/" + signupId + "/contacts", urlParams, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * addSignupContact
     * @param signupId
     * @param name
     * @param type
     * @param email
     * @param phone
     * @param callback
     */
    SignupMixin.prototype.addSignupContact = function (signupId, name, type, email, phone, callback) {
        var _this = this;
        var body = {
            name: name,
            type: type,
            email: email,
            phone: phone,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/signups/" + signupId + "/contacts", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editSignupContact
     * @param signupId
     * @param contactId
     * @param name
     * @param type
     * @param email
     * @param phone
     * @param callback
     */
    SignupMixin.prototype.editSignupContact = function (signupId, contactId, name, type, email, phone, callback) {
        var _this = this;
        var body = {
            name: name,
            type: type,
            email: email,
            phone: phone,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/signups/" + signupId + "/contacts/" + contactId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * removeSignupContact
     * @param signupId
     * @param contactId
     * @param callback
     */
    SignupMixin.prototype.removeSignupContact = function (signupId, contactId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/signups/" + signupId + "/contacts/" + contactId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSignupTimeline
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.getSignupTimeline = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.TimelineEntry.parse, 'warn'));
        };
        this.http.get("/signups/" + signupId + "/timeline", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * postToSignupTimeline
     * @param signupId
     * @param message
     * @param callback
     */
    SignupMixin.prototype.postToSignupTimeline = function (signupId, message, callback) {
        var _this = this;
        var body = {
            message: message,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.TimelineEntry.parse));
        };
        this.http.post("/signups/" + signupId + "/timeline", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getSignupData
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.getSignupData = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.DataEntry.parse, 'warn'));
        };
        this.http.get("/signups/" + signupId + "/data", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * watchSignup
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.watchSignup = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/signups/" + signupId + "/watch", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * unwatchSignup
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.unwatchSignup = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/signups/" + signupId + "/watch", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * createSignup
     * @param name
     * @param region
     * @param country
     * @param alertEmail
     * @param salesLeadId
     * @param technicalLeadId
     * @param contactName
     * @param contactType
     * @param contactEmail
     * @param contactPhone
     * @param products
     * @param callback
     */
    SignupMixin.prototype.createSignup = function (name, region, country, alertEmail, salesLeadId, technicalLeadId, contactName, contactType, contactEmail, contactPhone, products, callback) {
        var _this = this;
        var body = {
            name: name,
            region: region,
            country: country,
            alertEmail: alertEmail,
            salesLeadId: salesLeadId,
            technicalLeadId: technicalLeadId,
            contactName: contactName,
            contactType: contactType,
            contactEmail: contactEmail,
            contactPhone: contactPhone,
            products: products.map(function (e) { return models_1.SignupProductType[e]; }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, models_1.MinimalSignup.parse));
        };
        this.http.post('/signups', null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * editSignup
     * @param signupId
     * @param name
     * @param region
     * @param country
     * @param alertEmail
     * @param salesLeadId
     * @param technicalLeadId
     * @param products
     * @param callback
     */
    SignupMixin.prototype.editSignup = function (signupId, name, region, country, alertEmail, salesLeadId, technicalLeadId, products, callback) {
        var _this = this;
        var body = {
            name: name,
            region: region,
            country: country,
            alertEmail: alertEmail,
            salesLeadId: salesLeadId,
            technicalLeadId: technicalLeadId,
            products: products.map(function (e) { return models_1.SignupProductType[e]; }),
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/signups/" + signupId, null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * getRegionsForCountry
     * @param country
     * @param callback
     */
    SignupMixin.prototype.getRegionsForCountry = function (country, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.Region.parse, 'throw'));
        };
        this.httpNonSupport.get("/countries/" + models_1.CountryKey[country] + "/regions", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * archiveSignup
     * @param signupId
     * @param notify
     * @param callback
     */
    SignupMixin.prototype.archiveSignup = function (signupId, notify, callback) {
        var _this = this;
        var body = {
            notify: notify != null ? models_1.ArchiveSignupNotifyAction[notify] : null,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/signups/" + signupId + "/archive", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * unarchiveSignup
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.unarchiveSignup = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/signups/" + signupId + "/unarchive", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * sendSignupWelcome
     * @param signupId
     * @param contactId
     * @param callback
     */
    SignupMixin.prototype.sendSignupWelcome = function (signupId, contactId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/signups/" + signupId + "/contacts/" + contactId + "/complete", null, null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * linkSignupToAgency
     * @param signupId
     * @param agencyId
     * @param callback
     */
    SignupMixin.prototype.linkSignupToAgency = function (signupId, agencyId, callback) {
        var _this = this;
        var body = {
            agencyId: agencyId,
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.put("/signups/" + signupId + "/agency-link", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * unlinkSignupFromAgency
     * @param signupId
     * @param callback
     */
    SignupMixin.prototype.unlinkSignupFromAgency = function (signupId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/signups/" + signupId + "/agency-link", null, this.unauthenticatedCallback(wrappedCallback));
    };
    return SignupMixin;
}());
exports.default = SignupMixin;
//# sourceMappingURL=SignupMixin.js.map